/**
 * Frontend Role Configuration - Laravel Equivalent
 * Mirrors backend role configuration for client-side role checking
 */

const rolesAndPermissions = {
  roles: {
    "SYSTEM-ADMINISTRATOR": {
      id: 1,
      display_name: "System Administrator",
      description: "High level administrator",
      level: 9,
    },
    "SENIOR-MANAGEMENT": {
      id: 2,
      display_name: "Senior Management",
      description:
        "They will be able to see all aspects of the system (a super user) so they can see what is happening in each area of the business",
      level: 8,
    },
    "MAINTENANCE-FULL": {
      id: 3,
      display_name: "Maintenance Full",
      description:
        "GG staff who sort out issues with the properties with full access",
      level: 7,
    },
    "MAINTENANCE-BASIC": {
      id: 4,
      display_name: "Maintenance Basic",
      description:
        "GG staff who sort out issues with the properties with basic access",
      level: 6,
    },
    "GUARDIAN-MANAGER": {
      id: 5,
      display_name: "Guardian Manager",
      description: "The GG staff setting up and managing guardians",
      level: 5,
    },
    SALES: {
      id: 6,
      display_name: "Sales",
      description: "The GG staff adding properties to the system",
      level: 4,
    },
    "SALES-LIMITED": {
      id: 7,
      display_name: "Sales Limited",
      description:
        "The GG staff adding properties to the system - limited access",
      level: 3,
    },
    CLIENT: {
      id: 8,
      display_name: "Client",
      description: "Someone who owns the property that GG manage",
      level: 2,
    },
    GUARDIAN: {
      id: 9,
      display_name: "Guardian",
      description: "Someone who lives in one of GG properties",
      level: 1,
    },
    CONTRACTOR: {
      id: 10,
      display_name: "Contractor",
      description: "Entity of Contractor.",
      level: 0,
    },
    "SALES WITH GUARDIANS": {
      id: 11,
      display_name: "Sales with guardians",
      description:
        "The GG staff adding properties to the system with access to guardians",
      level: 4,
    },
    "MAINTENANCE-MEDIUM": {
      id: 12,
      display_name: "Maintenance Medium",
      description:
        "GG staff who sort out issues with the properties with medium access",
      level: 6,
    },
    "GUARDIAN-MANAGER-WITH-MAINTENANCE": {
      id: 13,
      display_name: "Guardian Manager with maintenance",
      description: "Guardian Manager with maintenance",
      level: 5,
    },
    "GUARDIAN-MAINTENANCE-CLIENT": {
      id: 14,
      display_name: "Guardian Manager with maintenance and clients",
      description: "Guardian Manager with maintenance and clients",
      level: 5,
    },
    "GUARDIAN-MANAGER-WITH-PROPERTIES-EDIT": {
      id: 15,
      display_name: "Guardian Manager with properties edit",
      description: "Guardian Manager with properties edit",
      level: 5,
    },
    "CONTRACTOR-READ-ONLY": {
      id: 16,
      display_name: "Contractor only read",
      description: "Contractor only read",
      level: 5,
    },
  },

  // Role hierarchy utility methods
  getRoleByName: (roleName) => {
    return rolesAndPermissions.roles[roleName] || null;
  },

  getRoleLevel: (roleName) => {
    const role = rolesAndPermissions.getRoleByName(roleName);
    return role ? role.level : -1;
  },

  hasRoleLevel: (userRoles, minimumLevel) => {
    if (!Array.isArray(userRoles)) {
      userRoles = [userRoles];
    }

    const maxUserLevel = Math.max(
      ...userRoles.map((roleName) => rolesAndPermissions.getRoleLevel(roleName))
    );

    return maxUserLevel >= minimumLevel;
  },

  hasRoleOrHigher: (userRoles, targetRole) => {
    const targetLevel = rolesAndPermissions.getRoleLevel(targetRole);
    return rolesAndPermissions.hasRoleLevel(userRoles, targetLevel);
  },

  isAdminRole: (roleName) => {
    return rolesAndPermissions.getRoleLevel(roleName) >= 7;
  },

  isManagementRole: (roleName) => {
    return rolesAndPermissions.getRoleLevel(roleName) >= 5;
  },

  isStaffRole: (roleName) => {
    return rolesAndPermissions.getRoleLevel(roleName) >= 3;
  },

  getRoleDisplayName: (roleName) => {
    const role = rolesAndPermissions.getRoleByName(roleName);
    return role ? role.display_name : roleName;
  },
};

export default rolesAndPermissions;







